import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { PrivateRoute } from '../privateRoute.jsx';
import * as styles from "./tanks.module.scss";
import { withTranslation, Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import TanksOperationsList from "./tank_operation/tanks_operations.jsx"
import TanksStateOperationsList from "./tank_state_operation/tanks_state_operations.jsx"
import TanksList from "./tank/tanks";

class TanksPage extends React.Component {
    render() {
        return (
            <div>
                <div className={styles.tanks_page_header_container}>
                    <div>
                        <ul>
                            <li>
                                <NavLink to="/tanks/tanks" activeClassName={styles.is_active}><Trans>TanksPagesNames.Tanks</Trans></NavLink>
                            </li>
                            <li>
                                <NavLink to="/tanks/tanksoperations" activeClassName={styles.is_active}><Trans>TanksPagesNames.TankOperations</Trans></NavLink>
                            </li>
                            <li>
                                <NavLink to="/tanks/tankstates" activeClassName={styles.is_active}><Trans>TanksPagesNames.TanksStateOperations</Trans></NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <Switch>
                        <PrivateRoute exact path="/tanks/tanks" component={TanksList}/>
                        <PrivateRoute exact path="/tanks/tanksoperations" component={TanksOperationsList} />
                        <PrivateRoute exact path="/tanks/tankstates" component={TanksStateOperationsList} />
                        <Redirect from="/tanks" to="/tanks/tanks" />
                    </Switch>
                </div>
            </div>
        );
    }
}

export default withTranslation('translations')(TanksPage);